






import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CodeTimeout extends Vue {
  @Prop(Number) value?: number

  interval: number = 0

  get valueString(): string {
    if (!this.value) {
      return ''
    }

    return this.value > 9 ? this.value.toLocaleString() : `0${this.value}`
  }

  mounted() {
    let timeoutValue = this.value as number

    this.interval = setInterval(() => {
      if (timeoutValue > 0) {
        timeoutValue--
        this.input(timeoutValue)
      } else {
        if (this.interval) {
          clearInterval(this.interval)
        }

        this.input(0)
      }
    }, 1000)
  }

  destroyed() {
    if (this.interval) {
      clearInterval(this.interval)
    }

    this.timeout()
  }

  @Emit()
  input(value: number) {
    return value
  }

  @Emit()
  timeout() {
    return true
  }
}
